import { render } from "./MainBar.vue?vue&type=template&id=1bfe696a&scoped=true"
import script from "./MainBar.vue?vue&type=script&lang=js"
export * from "./MainBar.vue?vue&type=script&lang=js"

import "./MainBar.vue?vue&type=style&index=0&id=1bfe696a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/zamon-vue/zamon-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bfe696a"]])

export default __exports__